@if (isAuthenticated) {
  <app-version-nav></app-version-nav>
} @else {
  <app-header></app-header>
}
<div class="legal-container">
  <div class="legal-content">
    <h1>Privacy Policy</h1>
    <p class="last-updated">Last Updated: {{ currentDate | date:'longDate' }}</p>

    <section class="legal-section">
      <h2>1. Introduction</h2>
      <p>
        AIOptima ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy 
        explains how we collect, use, disclose, and safeguard your information when you use our platform 
        and services.
      </p>
    </section>

    <section class="legal-section">
      <h2>2. Information We Collect</h2>
      <p>We collect information that you provide directly to us, including:</p>
      <ul>
        <li>Account information (name, email address, phone number)</li>
        <li>Business information (company name, industry, business type)</li>
        <li>Usage data and analytics</li>
        <li>Brand and project data you submit for analysis</li>
        <li>Communication data when you contact us</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>3. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide, maintain, and improve our services</li>
        <li>Process your requests and transactions</li>
        <li>Send you technical notices and support messages</li>
        <li>Respond to your comments and questions</li>
        <li>Monitor and analyze trends and usage</li>
        <li>Detect, prevent, and address technical issues</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>4. Information Sharing and Disclosure</h2>
      <p>
        We do not sell, trade, or rent your personal information to third parties. We may share your 
        information only in the following circumstances:
      </p>
      <ul>
        <li>With your consent</li>
        <li>To comply with legal obligations</li>
        <li>To protect our rights and safety</li>
        <li>With service providers who assist us in operating our platform</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>5. Data Security</h2>
      <p>
        We implement appropriate technical and organizational security measures to protect your personal 
        information. However, no method of transmission over the Internet or electronic storage is 100% 
        secure, and we cannot guarantee absolute security.
      </p>
    </section>

    <section class="legal-section">
      <h2>6. Data Retention</h2>
      <p>
        We retain your personal information for as long as necessary to fulfill the purposes outlined in 
        this Privacy Policy, unless a longer retention period is required or permitted by law.
      </p>
    </section>

    <section class="legal-section">
      <h2>7. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access and receive a copy of your personal data</li>
        <li>Rectify inaccurate or incomplete data</li>
        <li>Request deletion of your personal data</li>
        <li>Object to processing of your personal data</li>
        <li>Request restriction of processing</li>
        <li>Data portability</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>8. Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking technologies to track activity on our platform and hold 
        certain information. You can instruct your browser to refuse all cookies or to indicate when a 
        cookie is being sent. For more information, please see our Cookie Policy.
      </p>
    </section>

    <section class="legal-section">
      <h2>9. Children's Privacy</h2>
      <p>
        Our Service is not intended for children under the age of 18. We do not knowingly collect 
        personal information from children under 18.
      </p>
    </section>

    <section class="legal-section">
      <h2>10. Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you of any changes by 
        posting the new Privacy Policy on this page and updating the "Last Updated" date.
      </p>
    </section>

    <section class="legal-section">
      <h2>11. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us through our platform 
        or support channels.
      </p>
    </section>
  </div>
</div>
